<template>
  <div id="app" class="h-screen bg-secondary-50 flex flex-col">
    <LayoutHeader v-if="authStore.isAuthenticated" />
    <main class="flex-1 overflow-auto">
      <router-view />
    </main>
    <footer class="py-2 text-center text-xs text-gray-400">
      Studiewijzer build v{{ appVersion }}
    </footer>
  </div>
</template>

<script setup>
import { useAuthStore } from './store/auth.js'
import LayoutHeader from './components/Layout/Header.vue'
import { APP_VERSION } from './utils/version.js'

const authStore = useAuthStore()
const appVersion = APP_VERSION

</script>
